import { createAction } from 'redux-actions';
import { GallectionType } from '../../types/gallection';
export interface FetchFoldersActionPayload {
  gallectionType: GallectionType;
}
export interface FetchFoldersSuccessActionPayload {
  gallectionType: GallectionType;
  ids: [number];
  entities: any;
}

export const fetchFolders = createAction<FetchFoldersActionPayload>(
  'FETCH_FOLDERS'
);
export const fetchFoldersSuccess = createAction<
  FetchFoldersSuccessActionPayload
>('FETCH_FOLDERS_SUCCESS');
